import { OpcoUserStatusType } from '../../types/types';
import { OPCO_USER_STATUSES } from '../const/const';

export const isBlockedOpcoUserStatus = (status: OpcoUserStatusType) => {
  return status === OPCO_USER_STATUSES.BLOCKED;
};
